import * as Types from '../../../../types.generated';

import { gql } from '@apollo/client';
import { ChatListItemFragmentDoc } from './ChatsNavSection.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CreateChatMutationVariables = Types.Exact<{
  input: Types.CreateChatInput;
}>;


export type CreateChatMutation = { __typename?: 'Mutation', createChat: { __typename?: 'ChatMutationResult', success: boolean, error?: { __typename?: 'Error', code: string } | null, chat?: { __typename?: 'Chat', id: string, chatType: Types.ChatType, viewerIsOwner: boolean, membersCanEditTitle: boolean, membersCanEditMembers: boolean, unreadCount: number, viewerArchivedAt?: string | null, latestMessageText?: string | null, latestMessageHasAttachments: boolean, title?: { __typename?: 'TranslationSet', en: string } | null, userSelectionSet: { __typename?: 'UserSelectionSet', id: string, userSelections: Array<{ __typename?: 'UserSelection', id: number, userMemberships: Array<{ __typename?: 'UserSelectionUser', id: number }> }> }, members: Array<{ __typename?: 'Employee', id: number, name: string, firstName: string, deactivatedAt?: string | null, profileImage?: { __typename?: 'Media', id: number, thumbnailImageUrl?: string | null, mediaUrls: { __typename?: 'TranslationSet', en: string }, imageUrls?: { __typename?: 'ImageUrls', id: string, thumb?: string | null, medium?: string | null, original: string } | null } | null }> } | null } };


export const CreateChatDocument = gql`
    mutation CreateChat($input: CreateChatInput!) {
  createChat(input: $input) {
    success
    error {
      code
    }
    chat {
      ...ChatListItem
    }
  }
}
    ${ChatListItemFragmentDoc}`;
export type CreateChatMutationFn = Apollo.MutationFunction<CreateChatMutation, CreateChatMutationVariables>;

/**
 * __useCreateChatMutation__
 *
 * To run a mutation, you first call `useCreateChatMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateChatMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createChatMutation, { data, loading, error }] = useCreateChatMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateChatMutation(baseOptions?: Apollo.MutationHookOptions<CreateChatMutation, CreateChatMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateChatMutation, CreateChatMutationVariables>(CreateChatDocument, options);
      }
export type CreateChatMutationHookResult = ReturnType<typeof useCreateChatMutation>;
export type CreateChatMutationResult = Apollo.MutationResult<CreateChatMutation>;
export type CreateChatMutationOptions = Apollo.BaseMutationOptions<CreateChatMutation, CreateChatMutationVariables>;